<template>
    <v-dialog v-model="showModal" persistent max-width="390">
        <v-card>
            <v-card-title class="headline greyMedium--text">{{ title }}</v-card-title>

            <v-card-text>
                <v-row>
                    <v-col class="pb-0" cols="12" sm="12" md="12">
                        <v-checkbox
                            v-model="modalChartOptions.showTarget"
                            :label="this.$t('component.stockChart.modal.configuration.target')"
                            :value="modalChartOptions.showTarget"
                            hide-details
                        ></v-checkbox>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="12" md="12">
                        <v-checkbox
                            v-model="modalChartOptions.showBreakout"
                            :label="this.$t('component.stockChart.modal.configuration.breakout')"
                            :value="modalChartOptions.showBreakout"
                            hide-details
                        ></v-checkbox>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="12" md="12">
                        <v-checkbox
                            v-model="modalChartOptions.showStopLoss"
                            :label="this.$t('component.stockChart.modal.configuration.stoploss')"
                            :value="modalChartOptions.showStopLoss"
                            hide-details
                        ></v-checkbox>
                    </v-col>
                    <v-col class="pt-0" cols="12" sm="12" md="12">
                        <v-checkbox
                            v-model="modalChartOptions.showSignalLine"
                            :label="this.$t('component.stockChart.modal.configuration.signalLine')"
                            :value="modalChartOptions.showSignalLine"
                            hide-details
                        ></v-checkbox>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="cancelButtonText" color="primary" outlined @click="cancel()">
                    {{ cancelButtonText }}
                </v-btn>
                <v-btn v-if="confirmButtonText" color="primary" @click="confirm()">
                    {{ confirmButtonText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';

  export default {
    name: 'ConfigurationModal',
    props: {
        chartOptions: Object,
        modalCode: { 
            type: String,
            required: true,
        },
    },
    data() {
        return {
            modalChartOptions: {
                showTarget: false,
                showBreakout: false,
                showStopLoss: false,
                showSignalLine: false
            }
        };
    },
    mounted() {
        this.modalChartOptions.showTarget = this.chartOptions.showTarget;
        this.modalChartOptions.showBreakout = this.chartOptions.showBreakout;
        this.modalChartOptions.showStopLoss = this.chartOptions.showStopLoss;
        this.modalChartOptions.showSignalLine = this.chartOptions.showSignalLine;
    },
    computed: {
        ...mapState('modal', ['modals']),
        showModal() {
            return this.modals[this.modalCode]?.show || false;
        },
        title() {
            return this.modals[this.modalCode]?.title || '';
        },
        confirmButtonText() {
            return this.modals[this.modalCode]?.confirmButtonText || '';
        },
        cancelButtonText() {
            return this.modals[this.modalCode]?.cancelButtonText || '';
        },
        onConfirm() {
            return this.modals[this.modalCode]?.onConfirm || null;
        },
        onCancel() {
            return this.modals[this.modalCode]?.onCancel || null;
        },
    },
    methods: {
        ...mapMutations('modal', ['hideModal']),
        cancel() {
            if (this.onCancel) this.onCancel();
            this.hideModal(this.modalCode);
        },
        confirm() {
            if (this.onConfirm) this.onConfirm();
            this.$emit("confirm", this.modalChartOptions);
            this.hideModal(this.modalCode);
        }
    },
  };
</script>
